<template>
  <div class="page-wrapper">
    <div class="container">

      <!-- Hero Section - Using PageHero component with large variant -->
      <PageHero title="Organlive.com" class="large">
        <template #subtitle>
          <a href="#" @click.prevent="playAudio">Tune in Now</a>
        </template>
      </PageHero>

      <!-- Welcome Section -->
      <section class="content-section">
        <p class="intro">
          Welcome to Organlive, the world's premiere 24/7 online radio station devoted entirely to the king of instruments. From cathedral lofts to concert halls, from historic tracker organs to modern symphonic giants, Organlive presents an unparalleled library of organ recordings from around the world — streaming any time, completely free to listeners.
        </p>
      </section>

      <!-- Listener Support Section -->
      <section class="content-section">
        <p>
          Organlive is listener supported. Since 2003, your contributions make it possible for us to maintain our broadcast, expand our music library, and continue sharing the beauty and diversity of the pipe organ with a worldwide audience. Thank you for helping us keep this unique resource available to all.
        </p>
      </section>

      <!-- Foundation Section -->
      <section class="content-section">
        <p>
          Organlive is a production of the <a href="https://organ.media" target="_blank" rel="noopener" class="link-primary">Organ Media Foundation</a>, a nonprofit organization dedicated to the promotion and preservation of organ music. Through radio, video, education, and special projects, the Foundation works to ensure that the art of the organ thrives for future generations.
        </p>
      </section>

      <!-- More Stations Section -->
      <section class="content-section stations">
        <h2>More Stations from the Organ Media Foundation</h2>
        <p class="stations-intro text-bold">
          Organlive is part of a family of stations dedicated to showcasing the full breadth of organ music:
        </p>

        <!-- Using ContentCard component -->
        <ContentCard
          title="Positively Baroque"
          link="https://www.positivelybaroque.com"
          icon="https://pictures.organlive.com/mobile/pb2_1024x1024.png"
          description="A carefully curated stream of Baroque organ and instrumental masterpieces. Experience the clarity, elegance, and expressive depth of Bach, Buxtehude, Bruhns, and their contemporaries."
        />

        <ContentCard
          title="Organ Experience"
          link="https://www.organexperience.com"
          icon="https://organ.media/mobile/oe_logo.png"
          description="A vibrant mix of Romantic, symphonic, and contemporary organ repertoire. From sweeping orchestral transcriptions to bold new compositions, Organ Experience highlights the full dramatic power of the instrument with themed blocks of music."
        />

        <p class="network-tagline text-bold text-italic">
          Together, these stations form the most comprehensive online organ-music network available anywhere.
        </p>
      </section>

      <!-- Explore Section -->
      <section class="content-section explore">
        <h2>Explore. Discover. Enjoy.</h2>
        <p>
          Whether you're an organist, a student, a lifelong enthusiast, or simply curious about the instrument's unique sound, Organlive welcomes you. Browse our extensive
          <router-link to="/search" class="link-primary">album library</router-link>, explore artist and organ pages, discover
          <router-link to="/newadditions" class="link-primary">new recordings</router-link>, or simply
          <a href="#" @click.prevent="playAudio" class="link-primary">press play</a> and enjoy the music.
        </p>
        <p class="closing text-bold text-center">
          Thank you for listening — and for supporting the world's most beautiful instrument.
        </p><p>Organlive.com <router-link to="/privacy" class="link-primary">Privacy Policy</router-link>.</p>
      </section>

    </div>
  </div>
</template>

<script>
import eventBus from '@/eventBus'
import PageHero from '@/components/PageHero.vue'
import ContentCard from '@/components/ContentCard.vue'

export default {
  name: 'HomePage',
  components: {
    PageHero,
    ContentCard
  },
  mounted () {
    document.title = 'Organlive.com'
  },
  methods: {
    playAudio () {
      eventBus.emit('toggle-play')
    }
  }
}
</script>

<style scoped>
/* Page-specific styles only - most styling is now global */

.stations-intro {
  margin-bottom: 1.5rem;
}

.network-tagline {
  margin-top: 1.5rem;
}

.closing {
  font-size: 1.15rem;
  margin-top: 1.5rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .closing {
    font-size: 1.05rem;
  }
}
</style>
